/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 */

import ErrorDecoder from './ErrorDecoder';

export default ErrorDecoder;
